import React, { PropTypes } from 'react'
import { Relayout, RelayoutItem } from 'relayout'
import { Link } from 'react-router'
import CSSModules from 'react-css-modules'

import PrimaryButton from 'components/primary-button'
import PrimaryButtonResponsive from 'components/primary-button-responsive'
import SecondaryButton from 'components/secondary-button'
import ButtonGroup from 'components/button-group'

import styles from './deal-list-header.css'

const DealListHeader = ({ editable, onChangeMode, onSave, saving, historyLink }) => (
  <div styleName={editable ? 'deal-list-header-editable' : 'deal-list-header-normal'}>
    <Relayout>
      <RelayoutItem sm={editable ? '0' : '4'} md="4">
        <div styleName="title">Tickets</div>
      </RelayoutItem>
      <RelayoutItem sm={editable ? '0' : '8'} md="8">
        <div styleName="buttons">
          {editable ?
            <div>
              <SecondaryButton disabled={saving} label="Cancel" onClick={onChangeMode} />
              <div styleName="save-button">
                <PrimaryButton disabled={saving} label="Save" onClick={onSave} />
              </div>
            </div>
          :
            <div>
              <Link styleName="history-button" to={historyLink}>
                <PrimaryButtonResponsive disabled={saving} label="History" />
              </Link>
              <PrimaryButtonResponsive disabled={saving} label="Edit" onClick={onChangeMode} />
            </div>
          }
        </div>
      </RelayoutItem>
      <RelayoutItem sm={editable ? '12' : '0'} md="0">
        <div styleName="button-group">
          <ButtonGroup
            buttons={[
              { text: 'Cancel', onClick: onChangeMode },
              { text: 'Save', onClick: onSave, isPrimary: true },
            ]}
            disabled={saving}
          />
        </div>
      </RelayoutItem>
    </Relayout>
  </div>
)

DealListHeader.propTypes = {
  editable: PropTypes.bool,
  historyLink: PropTypes.string,
  onChangeMode: PropTypes.func,
  onSave: PropTypes.func,
  saving: PropTypes.bool,
}

export default CSSModules(DealListHeader, styles, { allowMultiple: true })



/** WEBPACK FOOTER **
 ** ./src/components/deal-list-header/deal-list-header.js
 **/